<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p13"><span><a id="page_10"></a><a href="#/Contents#rp13">NO-SALT VEGETABLE STOCK</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="imagela"><span><img alt="" height="49" src="images/45ref.jpg" width="25"/></span></p>
<p class="normal"><span><i>This no-salt-added vegetable stock with its light onion flavor makes a perfect base for many of the soups and stews in this book.</i></span></p>
<p class="make"><span>Makes about 2 quarts</span></p>
<p class="hang"><span>2½ quarts water</span></p>
<p class="hang"><span>3 each: quartered medium onions, halved carrots, ribs celery</span></p>
<p class="hang"><span>2 bay leaves</span></p>
<p class="hang"><span>¼ cup packed fresh basil</span></p>
<p class="hang"><span>10 whole white peppercorns</span></p>
<p class="hang"><span>1 teaspoon dried thyme leaves</span></p>
<p class="normalt"><span><b>1.</b> Heat all ingredients to boiling in large saucepan; reduce heat and simmer, covered, 30 minutes. Strain stock through double layer of cheesecloth, discarding vegetables and seasoning.</span></p>
<p class="per"><span>Per Cup:</span></p>
<p class="per1"><span>Calories: 5</span></p>
<p class="per1"><span>% calories from fat: 0</span></p>
<p class="per1"><span>Protein (g): 0.1</span></p>
<p class="per1"><span>Carbohydrate (g): 1.1</span></p>
<p class="per1"><span>Fat (g): 0</span></p>
<p class="per1"><span>Saturated fat (g): 0</span></p>
<p class="per1"><span>Cholesterol (mg): 0</span></p>
<p class="per1"><span>Sodium (mg): 2</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 0.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0113.vue?ca791df0